module.exports = __webpack_public_path__ + "img/2x.110d2c4.jpg";